'use client';

import { useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { useLocale } from './LocaleProvider';
import { dict, t } from '@/lib/i18n';

export function FAQ() {
  const { locale } = useLocale();
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="relative py-14 md:py-28">
      <div className="mx-auto max-w-3xl px-6">
        <div className="mb-12 text-center">
          <div className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-gold-soft font-semibold mb-4">
            <span className="w-1 h-1 rounded-full bg-gold-soft" />
            {t(dict.faq.eyebrow, locale)}
          </div>
          <h2 className="font-serif text-display-sm text-cream leading-[0.98]">
            {t(dict.faq.heading, locale)}
          </h2>
        </div>

        <div className="space-y-3">
          {dict.faq.items.map((item, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={i}
                className="rounded-luxe border border-white/10 bg-ink-800/50 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIdx(isOpen ? null : i)}
                  className="w-full px-6 py-5 flex items-center justify-between gap-4 text-start hover:bg-white/[0.02] transition-colors duration-150 ease-out"
                  aria-expanded={isOpen}
                >
                  <span className="font-serif text-lg text-fog-100 leading-snug">
                    {t(item.q, locale)}
                  </span>
                  <span
                    className={`w-8 h-8 shrink-0 rounded-full border grid place-items-center text-lg leading-none transition-[transform,background-color,border-color,color] duration-200 ease-out ${
                      isOpen
                        ? 'rotate-45 bg-gold/10 border-gold/30 text-gold-soft'
                        : 'border-white/10 text-fog-300'
                    }`}
                    aria-hidden
                  >
                    +
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.28, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <div className="px-6 pb-6 text-fog-300 leading-relaxed">
                        {t(item.a, locale)}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
